import { render, staticRenderFns } from "./TournamentCategoryList.vue?vue&type=template&id=6faacb3e&scoped=true&"
import script from "./TournamentCategoryList.vue?vue&type=script&lang=js&"
export * from "./TournamentCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./TournamentCategoryList.vue?vue&type=style&index=0&id=6faacb3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faacb3e",
  null
  
)

export default component.exports